import { render, staticRenderFns } from "./RenderBitcoin.vue?vue&type=template&id=65c97e8b&scoped=true&"
import script from "./RenderBitcoin.vue?vue&type=script&lang=js&"
export * from "./RenderBitcoin.vue?vue&type=script&lang=js&"
import style0 from "./RenderBitcoin.vue?vue&type=style&index=0&id=65c97e8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c97e8b",
  null
  
)

export default component.exports